import $ from "jquery";
import { domReady } from "../functions/utility.js";

const $body = $("body");
const $mainmenuToggler = $("#mainmenu-toggler");
const $mainMenu = $("#mainmenu");
const $subnavToggler = $("#subnav-toggler");
const $subnav = $("#subnav");

const openMenu = () => {
  $body.addClass("menu-open");
  $mainMenu.slideDown();
};

const closeMenu = () => {
  $body.removeClass("menu-open");
  $mainMenu.slideUp();
};

const openSubNav = () => {
  $body.addClass("subnav-open");
  $subnav.slideDown();
};

const closeSubNav = () => {
  $body.removeClass("subnav-open");
  $subnav.slideUp();
};

const main = () => {
  let menuItems = document.querySelectorAll(".nav-item.has-submenu .nav-link");
  if (menuItems.length === 0) return;

  menuItems.forEach((item) => {
    item.addEventListener("click", (e) => {
      let parentItem = item.closest(".nav-item.has-submenu");
      let closeBtn = parentItem.querySelector(".close-btn");
      let submenu = parentItem.querySelector(".submenu-wrapper");

      // Collapse other items
      menuItems.forEach((otherItem) => {
        let parentEl = otherItem.closest(".nav-item.has-submenu");
        let submenuWrapper = parentEl.querySelector(".submenu-wrapper");
        if (parentItem !== parentEl) {
          parentEl.classList.remove("expanded");
          if (window.innerWidth < 992) $(submenuWrapper).slideUp();
        }
      });

      if (parentItem.classList.contains("expanded")) {
        parentItem.classList.remove("expanded");
        if (window.innerWidth < 992) $(submenu).slideUp();
        return;
      } else {
        if (window.innerWidth < 992) $(submenu).slideDown();
      }

      parentItem.classList.add("expanded");

      if (closeBtn) {
        closeBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          parentItem.classList.remove("expanded");
        });
      }
    });
  });
};

export const init = () => {
  $mainmenuToggler.on("click", function (e) {
    e.preventDefault();

    if (!$body.hasClass("menu-open")) {
      openMenu();
    } else {
      closeMenu();
    }
  });

  document.addEventListener("click", (e) => {
    if (
      $body.hasClass("menu-open") &&
      e.target.closest("#mainmenu") == null &&
      e.target.closest("#mainmenu-toggler") == null
    ) {
      closeMenu();
    }
  });

  $subnavToggler.click(function (e) {
    e.preventDefault();

    if (!$body.hasClass("subnav-open")) {
      openSubNav();
    } else {
      closeSubNav();
    }
  });

  document.addEventListener("click", (e) => {
    if (
      $body.hasClass("subnav-open") &&
      e.target.closest("#subnav") == null &&
      e.target.closest("#subnav-toggler") == null
    ) {
      closeSubNav();
    }
  });

  $(window).on("load resize", function () {
    var windowWidth = window.innerWidth;
    if (windowWidth >= 992) {
      $body.removeClass("subnav-open");
      $mainMenu.removeAttr("style");
      $(".subnav .has-submenu").removeClass("open");
      $(".subnav .has-submenu > ul").removeAttr("style");
      $(".submenu-wrapper").removeAttr("style");
    } else {
      $body.removeClass("menu-open");
      $mainMenu.removeAttr("style");
      $(".submenu-wrapper").removeAttr("style");
    }
  });

  let $subItemsTogglers = $(".subnav .has-submenu > a > .ai");
  $subItemsTogglers.on("click", function (e) {
    e.preventDefault();
    var windowWidth = window.innerWidth;
    if (windowWidth < 992) {
      let $parentItem = $(this).closest(".has-submenu");
      let isOpen = $parentItem.hasClass("open");
      $(".subnav .has-submenu").removeClass("open");
      $(".subnav .has-submenu > ul").slideUp();
      if (!isOpen) {
        $parentItem.addClass("open");
        $parentItem.find(" > ul").slideDown();
      } else {
        $parentItem.removeClass("open");
        $parentItem.find(" > ul").slideUp();
      }
    }
  });

  // Close menu and search when modal is open
  let $modalBtns = $('[data-bs-toggle="modal"]');
  $modalBtns.each(function (index) {
    $(this).on("click", function (e) {
      if ($body.hasClass("search-open")) {
        $("body").removeClass("search-open");
        $("#search").slideUp();
      }
      if ($body.hasClass("menu-open")) {
        $("body").removeClass("menu-open");
        $("#mainmenu").slideUp();
      }
    });
  });

  /*---------sticky header---------*/
  function updateStickyHeader() {
    if (window.scrollY >= 50) {
      document.body.classList.add("sticky-header");
    } else {
      document.body.classList.remove("sticky-header");
    }
    if (window.innerWidth < 992) {
      document.body.classList.add("sticky-header");
    }
  }
  $(window).on("resize scroll", updateStickyHeader);
  updateStickyHeader();
  /*---------/sticky header ---------*/

  domReady().then(() => main());
};
